import videoPlayer from "../../shared/videoPlayer";
import selectDate from "../../shared/selectDate";
import dynamicChangePrice from "../../shared/videos/dynamicChangePrice";
import sceneMove from "../../shared/videos/sceneMove";
import videoCardHover from "../../shared/videoCardHover";

// 引数はビューが body の data-view-script-args に JSON で渡す (@see viewScript.js)。
// 以前はインライン script から文字列として渡していたため "true" との比較だった。
// JSON になったので真偽値をそのまま受け取る (#2935)
export default (videoId, isFreeWithoutCampaign) => {
  videoPlayer();

  let config = { minDate: "today" };

  // 0円の動画の使用可能期間は90日までと制限する処理
  if (isFreeWithoutCampaign) {
    const additionalConfig = { maxDate: new Date().fp_incr(90) };
    config = { ...config, ...additionalConfig };
  }

  selectDate(config);
  dynamicChangePrice(videoId);
  sceneMove();
  videoCardHover();
};
